const Alert = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="bg-orange-100 text-orange-800 px-4 py-3 rounded ">
            {children}
        </div>
    );
};

export default Alert;
